// extracted by mini-css-extract-plugin
module.exports = {"bankidinfo":"bankidinfo__ly7o_","center":"center__QU0vQ","inputfield":"inputfield__3Q-ut","inputblock":"inputblock__3Zark","btns":"btns__1_zd3"};